import React from 'react';
import { DynamicUiProvider } from 'src/UI/dynamicUI/DynamicUiProvider';
import { UseFormReturnType } from '@mantine/form';
import { DynamicUiData, FormValuesType } from 'src/UI/dynamicUI/types';
import { fakeSection } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';

type Props = {
  children?: React.ReactNode;
  form: UseFormReturnType<FormValuesType>;
  uiData: DynamicUiData;
  isCreateMode: boolean;
  onDeleteConfirm?: () => void;
};

export function DynamicUiProviderWrapper({
  form,
  uiData,
  isCreateMode,
  onDeleteConfirm,
  children,
}: Props) {
  const [isEditing, setIsEditing] = React.useState(isCreateMode);
  const { client } = useCurrentClientIfAvailable();
  return (
    <DynamicUiProvider
      form={form}
      uiData={uiData}
      currentSection={fakeSection}
      isEditable={true}
      isEditing={isEditing}
      setIsEditing={editing => {
        setIsEditing(editing);
      }}
      toggleEditing={() => {
        setIsEditing(!isEditing);
      }}
      isDeletable={!isCreateMode}
      isCreateMode={isCreateMode}
      onDelete={isCreateMode ? () => {} : onDeleteConfirm}
      clientId={client?.id}
    >
      {children}
    </DynamicUiProvider>
  );
}
